import styled from 'styled-components';

import {
  IconArrowCounterclockwise as ArrowCounterclockwise,
  IconFullscreenExit as FullScreenExitIcon,
  IconFullscreen as Fullscreen,
  IconZoomIn as ZoomIn,
  IconZoomOut as ZoomOut,
} from '../../core';

import { usePageActions } from './context';

interface Props {
  className?: string;
}

const PageActions = ({ className = '' }: Props) => {
  const { zoomIn, zoomOut, resetSettings, fullScreen, resetScreen, isFullScreen } =
    usePageActions();

  return (
    <div className={className}>
      <div className="button-list">
        <button type="button" aria-label="Zoom in" onClick={zoomIn}>
          <ZoomIn />
        </button>
        <button type="button" aria-label="Zoom out" onClick={zoomOut}>
          <ZoomOut />
        </button>
        <button type="button" aria-label="Reset the chart" onClick={resetSettings}>
          <ArrowCounterclockwise />
        </button>
        {!isFullScreen && (
          <button
            type="button"
            aria-label="Enter full screen"
            onClick={() => {
              fullScreen();
            }}
          >
            <Fullscreen />
          </button>
        )}
        {isFullScreen && (
          <button
            type="button"
            aria-label="Exit full screen"
            onClick={() => {
              resetScreen();
            }}
          >
            <FullScreenExitIcon />
          </button>
        )}
      </div>
    </div>
  );
};

const StyledPageActions = styled(PageActions)`
  display: flex;
  padding: 8px;
  background-color: ${({ theme }) => theme.neutralBackgroundBase};
  align-items: center;
  border-radius: 6px;

  > .button-list {
    display: flex;
    gap: 8px;
    > button {
      display: flex;
      align-items: center;
      border: none;
      background-color: transparent;
      padding: 4px 8px;
      cursor: pointer;

      > svg {
        width: 16px;
        height: 16px;
      }
    }
  }
`;

export default StyledPageActions;
